import type React from "react";

interface WarningIconProps {
	size?: number;
	className?: string;
}

export const WarningIcon: React.FC<WarningIconProps> = ({
	size = 24,
	className = "",
}) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		aria-hidden="true"
	>
		<path
			d="M12 2L2 20h20L12 2z"
			fill="#FCD34D"
			stroke="#F59E0B"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M12 9v4M12 17h.01"
			stroke="#92400E"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
